import request from '@/utils/request'

// 列表  GET /spWorkWechat/autoScript/index
// Query: page, page_size, mobile_type, job_code
export function autoScriptIndex(params = {}) {
  return request({
    url: '/spWorkWechat/autoScript/index',
    method: 'get',
    params
  })
}

// 创建  POST /spWorkWechat/autoScript/create
// Body: mobile_type, job_code, script_content
export function autoScriptCreate(data = {}) {
  return request({
    url: '/spWorkWechat/autoScript/create',
    method: 'post',
    data
  })
}

// 详情  GET /spWorkWechat/autoScript/detail
// Query: id
export function autoScriptDetail(params = {}) {
  return request({
    url: '/spWorkWechat/autoScript/detail',
    method: 'get',
    params
  })
}

// 更新  POST /spWorkWechat/autoScript/update
// Body: id, mobile_type, job_code, script_content
export function autoScriptUpdate(data = {}) {
  return request({
    url: '/spWorkWechat/autoScript/update',
    method: 'post',
    data
  })
}

// 删除  POST /spWorkWechat/autoScript/destroy
// Body: id
export function autoScriptDelete(data = {}) {
  return request({
    url: '/spWorkWechat/autoScript/destroy',
    method: 'post',
    data
  })
}
